import { getCookie, setCookie, removeCookie } from '@services/cookies';
import { client } from '../apollo/client';
import { COOKIE_EXPIRES_IN, COOKIES } from '@constants/cookies';
import { USER_SIGN_OUT } from '@queries/user';

export const setToken = (token: string) => {
  setCookie(COOKIES.token, token, COOKIE_EXPIRES_IN.thirtyDays);
};

export const removeToken = () => {
  removeCookie(COOKIES.token);
  removeCookie(COOKIES.guestToken);
};

export const getToken = () => {
  const token = getCookie(COOKIES.token);
  return !!token;
};

let isLoggingOut = false;

export const logout = async () => {
  if (isLoggingOut) return;
  isLoggingOut = true;

  removeToken();
  removeCookie(COOKIES.basketId);

  try {
    await client.mutate({ mutation: USER_SIGN_OUT });
  } catch {
    // Sign-out call may fail if already unauthorized — safe to ignore
  }

  client.clearStore();
  isLoggingOut = false;
};
